import React from 'react';

function CompanyActivities() {
  return (
    <div className='hero__company-activities'>
      <div className='hero__decoration-box'>
        <div className='hero__decoration-figure'></div>
        <div className='hero__decoration-figure'></div>
        <div className='hero__decoration-figure'></div>
      </div>

      <p className='hero__description-activities'>
        Проектирование, поставка и монтаж систем вентиляции и кондиционирования
      </p>
    </div>
  );
}

export default CompanyActivities;
